import script from "./soldAnalyse.vue?vue&type=script&setup=true&lang=js"
export * from "./soldAnalyse.vue?vue&type=script&setup=true&lang=js"

import "./soldAnalyse.vue?vue&type=style&index=0&id=1fa43992&scoped=true&lang=css"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fa43992"]])

export default __exports__